<template>
    <v-container fluid class="pa-0" style="height: 100%;">
        <!--<div class="chart-title">{{ title }}</div>-->
        <div class="chart-title d-flex justify-space-between align-center mt-0">
            {{ title }}
            <table style="margin:0px">
                <tr>

                    <td>{{iconName}}</td>
                    <td width="10"></td>
                    <td>
                        <span class="icon">
                            <v-icon color="white" size="40">{{ icon }}</v-icon>
                        </span>
                    </td>
                </tr>
            </table>
        </div>
        
        <v-card style="background-color: #efeded; height: calc( 100% - 62px) ">
            <v-card-text>
                <v-row><v-col><v-icon @click="dialog = true" color="primary">mdi-brush-outline</v-icon></v-col></v-row>
                <!--<v-container v-if="quarters.length>0">
                    <v-row>
                        <v-col md="6" cols="12">-->
                            <!-- Filter by Year -->
                            <!--<v-menu v-model="yearMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field hide-details v-model="selectedYear" outlined clearable dense
                                                  :label="$t('Year')"
                                                  readonly
                                                  v-bind="attrs" @input="selectYear(null)"
                                                  v-on="on"></v-text-field>
                                </template>
                                <v-date-picker :max="maxDate"
                                               type="year" @click:year="selectYear($event)"></v-date-picker>
                            </v-menu>

                        </v-col>
                        <v-col md="6" cols="12">-->
                            <!-- Filter by Quarter (using Calendar) -->
                            <!--<v-select hide-details v-model="selectedQuarter" @input="selectQuarter($event)" clearable outlined dense
                                      :items="quarters"
                                      :label="$t('Quarter')"></v-select>
                        </v-col>
                    </v-row>
                </v-container>-->
            </v-card-text>
            <v-card-text class="d-flex flex-column align-center ">
                <v-row justify="center">
                    <v-col cols="auto">
                        <table>
                            <tr>
                                <td v-for="(value, index) in scores.slice(0, seven)" :key="'detractorspercentages-' + index" :style="index == six?'padding-right:2px':'padding-left:10px'">
                                    <v-card class="percTxt"><v-card-text style="width: 33px; height: 33px; line-height: 33px; text-align: center; padding: 0px; font-size: 21px; color: black">{{getScorePercentage(value)}}%</v-card-text></v-card>
                                </td>
                            </tr>
                            <tr>
                                <td v-for="(value, index) in scores.slice(0, seven)" :key="'detractorspercentagesempty-' + index" style="height:5px">
                                </td>
                            </tr>
                        </table>
                        <table style="background-color: rgba(244, 67, 54, 0.1); border-radius: 30px; margin-bottom: 10px;">

                            <tr><td v-for="(value, index) in scores.slice(0, seven)" :key="'detractors-' + index" :style="index == 6?'':'padding-left:10px' "><v-chip :color="redColor" class="white--text npsnumber" width="30" hwight="30" style="font-size: 21px;" @click="filterQuestionOption(value)">{{ value }}</v-chip></td></tr>
                        </table>
                        <div v-if="value.length>0" :style="`color:${redColor};font-size:21px;`">{{$t('AbsolutelyDontRecommend')}}</div>
                    </v-col>
                    <v-col cols="auto">
                        <table>
                            <tr>
                                <td v-for="(value, index) in scores.slice(seven, nine)" :key="'passivespercentages-' + index" :style="index == six?'padding-right:2px':'padding-left:10px'">
                                    <v-card class="percTxt"><v-card-text style="width: 33px; height: 33px; line-height: 33px; text-align: center; padding: 0px; font-size: 21px;color:black">{{getScorePercentage(value)}}%</v-card-text></v-card>
                                </td>
                            </tr>
                            <tr>
                                <td v-for="(value, index) in scores.slice(seven, nine)" :key="'passivespercentagesempty-' + index" style="height:5px">
                                </td>
                            </tr>
                        </table>
                        <table style="background-color: rgba(255, 193, 7, 0.1); border-radius: 30px;"><tr><td v-for="(value, index) in scores.slice(seven, nine)" :key="'passives-' + index" :style="index == 1?'':'padding-left:10px'"><v-chip width="30" hwight="30" :color="amberColor" class="white--text npsnumber" style="font-size: 21px;" @click="filterQuestionOption(value)">{{ value }}</v-chip></td></tr></table>
                    </v-col>
                    <v-col cols="auto" class="px-0">
                        <table>
                            <tr>
                                <td v-for="(value, index) in scores.slice(nine)" :key="'promoterspercentages-' + index" :style="index == six?'padding-right:2px':'padding-left:10px;'">
                                    <v-card class="percTxt"><v-card-text style="width: 50px; height: 33px; line-height: 33px; text-align: center; padding: 0px; font-size: 21px; color: black ">{{getScorePercentage(value)}}%</v-card-text></v-card>
                                </td>
                            </tr>
                            <tr>
                                <td v-for="(value, index) in scores.slice(nine)" :key="'promoterspercentagesempty-' + index" style="height:5px">
                                </td>
                            </tr>
                        </table>
                        <table style="background-color: rgba(0, 200, 83, 0.1); border-radius: 30px;width:80%; margin-bottom: 10px;"><tr><td v-for="(value, index) in scores.slice(nine)" :key="'promoters-' + index" :style="value == nine?'':'text-align:left'"><v-chip :color="greenColor" class="white--text npsnumber" style="font-size: 21px;" @click="filterQuestionOption(value)">{{ value }}</v-chip></td></tr></table>
                        <div v-if="value.length>0" :style="`color:${greenColor};font-size:21px;`">{{$t('StronglyRecommend')}}</div>
                    </v-col>
                    <v-col cols="auto">
                        <table style="font-size: 18px;border-right:1px solid black;padding-right:10px">
                            <tr><td valign="middle" align="left" style="color:black">{{$t('PROMOTERS')}}</td><td width="5"></td><td valign="middle"><img src="/face5.png" style="width:35px" /></td></tr>
                            <tr><td valign="middle" align="left" style="color:black">{{$t('PASSIVES')}}</td><td width="5"></td><td valign="middle"><img src="/face3.png" style="width:35px" /></td></tr>
                            <tr><td valign="middle" align="left" style="color:black">{{$t('DETRACTORS')}}</td><td width="5"></td><td valign="middle"><img src="/face1.png" style="width:35px" /></td></tr>
                        </table>
                    </v-col>
                </v-row>
                <v-row class="d-flex justify-space-between align-center" v-if="value.length>0">
                    
                    <v-col cols="auto">
                        <v-card flat style="background-color:transparent;">
                            <v-card-text>
                                <!--<v-progress-circular :value="npsScore"
                         :size="120"
                         :width="20"
                         :color="greenColor">
        <span style="font-size:20px">{{ npsScore }}%</span>
    </v-progress-circular>-->
                                <v-card class="pa-2 gradient-card"
                                        shaped
                                        elevation="2"
                                        :style="`width:100%; border-radius: 20px; position: relative; overflow: hidden; padding: 20px; background: ${titleColor}; ` ">
                                    <v-row align="center" justify="center" class="pa-2">
                                        <span class="white--text font-weight-bold">{{$t('NPS')}}</span>
                                    </v-row>
                                   
                                </v-card>
                                
                                <div class="ma-3" style="font-size:21px; width: 230px; height: 50px; text-align: center; line-height: 50px; color: black; border: 1px dashed black;border-radius:10px">{{ npsScore }}%</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-dialog v-model="dialog" persistent max-width="700px">
            <v-card>
                <div class="card-title">
                    {{ $t('ChangeColor')}}
                </div>
                <v-card-title></v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="4">
                            <v-color-picker v-model="redColor" mode="hexa"></v-color-picker>
                        </v-col>
                        <v-col cols="4">
                            <v-color-picker v-model="amberColor" mode="hexa"></v-color-picker>
                        </v-col>
                        <v-col cols="4">
                            <v-color-picker v-model="greenColor" mode="hexa"></v-color-picker>
                        </v-col>
                        <v-col cols="4">
                            <v-color-picker v-model="titleColor" mode="hexa"></v-color-picker>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="dialog = false" text>{{$t('Close')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </v-container>
</template>

<script>
    export default {
        data() {
            return {
                redColor: '#F44336',
                greenColor: '#00C853',
                amberColor: '#FFC107',
                titleColor:'#00bcd4',

                dialog: false,
                yearMenu: false,
                quarterMenu: false,
                selectedYear: null,
                selectedQuarter: null,
                maxDate: new Date().toISOString().split('T')[0],

            }
        },
        props: {
            value: {
                type: Array,
                default: () => [],
            },
            scores: {
                type: Array,
                default: () => [],
            },
            title: {
                type: String,
                default: () => '',
            },
            icon: {
                type: String,
                default: () => null,
            },
            iconName: {
                type: String,
                default: () => null,
            },
            quarters: {
                type: Array,
                default: () => [],
            },
            q: undefined
        },
        computed: {
            
            promoterPercentage() {
                const promoters = this.value.filter((r) => r.value >= this.nine).reduce((sum, item) => sum + item.count, 0)
                const totalCount = this.value.reduce((sum, item) => sum + item.count, 0)
                return ((promoters / totalCount) * 100).toFixed(1)
            },
            passivePercentage() {
                const passives = this.value.filter((r) => r.value >= this.seven && r.value <= this.eight).reduce((sum, item) => sum + item.count, 0)
                const totalCount = this.value.reduce((sum, item) => sum + item.count, 0)
                return ((passives / totalCount) * 100).toFixed(1)
            },
            detractorPercentage() {
                const detractors = this.value.filter((r) => r.value <= this.six).reduce((sum, item) => sum + item.count, 0)
                const totalCount = this.value.reduce((sum, item) => sum + item.count, 0)
                return ((detractors / totalCount) * 100).toFixed(1)
            },
            npsScore() {
                //return (this.promoterPercentage - this.detractorPercentage).toFixed(1)
                const score = this.promoterPercentage - this.detractorPercentage
                return Math.ceil(score)
            },
            six() {
                return Math.ceil((this.scores.length - 1) * 6 / 10)
            },
            seven() {
                return Math.ceil((this.scores.length - 1) * 7 / 10)
            },
            eight() {
                return Math.ceil((this.scores.length - 1) * 8 / 10)
            },
            nine() {
                return Math.ceil((this.scores.length - 1) * 9 / 10)
            },
            questionIcon() {
                return (iconTypeId) => {
                    let icon = ''
                    switch (iconTypeId) {
                        case 1:
                            icon = 'mdi-account-multiple-check-outline'
                            break
                        case 2:
                            icon = 'mdi-account-multiple-plus-outline'
                            break
                        case 3:
                            icon = 'mdi-account-group-outline'
                            break
                        default:
                            icon = ''
                            break
                    }
                    console.log('icon: ', icon)
                    console.log('iconTypeId: ', iconTypeId)
                    return icon
                }
            },
        },
        methods: {
            filterQuestionOption(score) {
                var item = this.value.filter(x => x.value == score)[0]
                this.$emit('filterQuestionOption', item, this.q, this.value)
            },
            getColor(index) {
                if (index >= 0 && index <= 1) return this.redColor
                if (index >= 2 && index <= 4) return this.amberColor
                return this.greenColor
            },
            getScorePercentage(score) {
                const count = this.value.filter((r) => r.value == score).reduce((sum, item) => sum + item.count, 0)
                const totalCount = this.value.reduce((sum, item) => sum + item.count, 0)
                return ((count / totalCount) * 100).toFixed(0)
            },
            getLabel(index) {
                if (index === 0) return 'لا أوصي على الإطلاق'
                if (index === 10) return 'أوصي تمامًا'
                return ''
            },
            selectYear(year) {
                this.selectedYear = year
                this.yearMenu = false
                this.yearPicker = null
                this.$emit('selectNPSYear', year)
            },
            selectQuarter(quarter) {
                this.$emit('selectNPSQuarter', quarter)
            }
        },
    }
</script>

<style>
    .text-center {
        text-align: center;
    }

    .npsnumber {
        padding: 0px;
        text-align: center;
        height: 30px !important;
        width: 30px !important;
        display: inline-block;
        border-radius: 100% !important;
        line-height: 30px;
    }
    .percTxt {
        background-color: transparent!important; box-shadow: none!important;
    }
    .gradient-card {
         /* Adjust colors to match */
        color: white; /* Ensures text remains readable */
    }
</style>
